import { AlertColor } from '@mui/material';
import * as React from 'react';
import { useContext, createContext } from 'react';

export type SnackBarProps = {
  severity: AlertColor,
  snackbarText: string,
  timeout: number | null,
  open: boolean
}

type ShowsnackbarProps = {
  severity?: AlertColor,
  snackbarText: string,
  timeout?: number,
}

const initialState: SnackBarProps = {
  severity: "success",
  snackbarText: "",
  timeout: 5000,
  open: false
}

interface SnackBarContextInterface {
  snackbarProps: SnackBarProps,
  setSnackbarProps: (language: SnackBarProps) => void,
  showSnackbar: (props: ShowsnackbarProps) => void;
  closeSnackbar: () => void,
}

const SnackBarContext = createContext<SnackBarContextInterface>({ snackbarProps: initialState, setSnackbarProps: () => { }, closeSnackbar: () => { }, showSnackbar: () => { } });

export const useSnackbarProps = () => useContext(SnackBarContext);

export function SnackbarPropsProvider(props: React.PropsWithChildren<{}>) {
  const [snackbarProps, setSnackbarProps] = React.useState<SnackBarProps>(initialState);

  const closeSnackbar = () => {
    setSnackbarProps(props => { return { ...props, open: false }; });
  }

  const showSnackbar = ({ snackbarText, severity = 'success', timeout = 5000 }: ShowsnackbarProps) => {
    setSnackbarProps({ open: true, snackbarText, severity, timeout });
  }

  const value = { snackbarProps, setSnackbarProps, closeSnackbar, showSnackbar };

  return <SnackBarContext.Provider value={value} {...props} />;
}
